import React from 'react';
interface SectionHeadingProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
  as?: 'h2' | 'h3';
}
export function SectionHeading({
  title,
  subtitle,
  tone = 'light',
  as = 'h2'
}: SectionHeadingProps) {
  const Tag = as;
  const isDark = tone === 'dark';
  return <div className="mx-auto max-w-2xl text-center" data-id="element-314" data-mp="3jzdocopo5ue0">
      <Tag className={`font-display text-[26px] font-bold leading-[1.15] sm:text-4xl lg:text-[42px] ${isDark ? 'text-cream-100' : 'text-navy-900'}`} data-id="element-315" data-mp="3k203paisxe6s">
        {title}
      </Tag>
      {subtitle ? <p className={`mx-auto mt-4 max-w-xl text-[15px] leading-relaxed sm:text-lg ${isDark ? 'text-cream-100/75' : 'text-navy-700/80'}`} data-id="element-316" data-mp="1v3jrn82jbna">
          {subtitle}
        </p> : null}
    </div>;
}